import React from 'react';
import { FaClock, FaChevronRight } from 'react-icons/fa';

import { GetSurveyForClientDto } from '../../../common/pokCore/autogenerated/pokApiClient';
import { useLocalTranslation } from '../../../common/hooks/useLocalTranslation';

interface PublicSurveyLandingProps {
  survey: GetSurveyForClientDto;
  logo?: string;
  onStart: () => void;
  currentLanguage?: string;
  isPreview?: boolean;
}

export const PublicSurveyLanding: React.FC<PublicSurveyLandingProps> = ({
  survey,
  logo,
  onStart,
  currentLanguage,
  isPreview = false,
}) => {
  const surveyBrandName = survey.company?.name || 'Group One';
  const surveyEstimatedTime = `${Math.max(2, Math.ceil((survey.questions?.length || 0) * 0.5))} min`;
  const { t, tk } = useLocalTranslation('administrationLng', currentLanguage);

  return (
    <div
      className={`public-survey-hero-bg ${isPreview ? 'public-survey-hero-bg--preview' : ''} d-flex align-items-center justify-content-center p-4`}
    >
      <div className="public-survey-decorative-bg">
        <div className="public-survey-bg-decoration public-survey-bg-decoration-primary public-survey-animate-pulse-soft" />
        <div className="public-survey-bg-decoration public-survey-bg-decoration-accent public-survey-animate-pulse-soft" />
      </div>

      <div className="public-survey-landing-wrapper public-survey-animate-slide-up">
        <div className="public-survey-landing-card public-survey-glass public-survey-shadow-lg">
          {logo && (
            <div className="public-survey-landing-logo-wrapper">
              <img
                src={logo}
                alt={surveyBrandName}
                className="public-survey-landing-logo"
              />
            </div>
          )}

          <h1 className="public-survey-landing-title text-center">
            {currentLanguage === 'PL' ? survey.name : survey.nameEn}
          </h1>

          {survey.client?.name && (
            <div className="text-center mb-3">
              <div className="public-survey-client-badge">
                <span className="public-survey-client-badge-label">
                  {t(tk.publicSurvey.surveyFor)}
                </span>
                <span className="public-survey-client-badge-name">
                  {survey.client?.name}
                </span>
              </div>
            </div>
          )}

          <div className="d-flex justify-content-center mb-4">
            <div className="public-survey-time-badge">
              <FaClock size={16} />
              <span>
                {t(tk.publicSurvey.estimatedTime)}: {surveyEstimatedTime}
              </span>
            </div>
          </div>

          <button onClick={onStart} className="public-survey-start-button">
            <span>{t(tk.publicSurvey.startSurvey)}</span>
            <FaChevronRight size={20} />
          </button>

          <p className="public-survey-landing-footer text-center text-muted mt-3">
            {t(tk.publicSurvey.numberOfQuestions)}: {survey.questions.length}
          </p>
        </div>
      </div>
    </div>
  );
};
